/*
 * School Management System API
 * APIs for managing branches, employees, students, receipts, etc.
 *
 * OpenAPI spec version: 1.0.0
 * Contact: tejabhargavpodila@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.54
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AddConcessionRequest model module.
 * @module model/AddConcessionRequest
 * @version 1.0.0
 */
export default class AddConcessionRequest {
  /**
   * Constructs a new <code>AddConcessionRequest</code>.
   * @alias module:model/AddConcessionRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AddConcessionRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AddConcessionRequest} obj Optional instance to populate.
   * @return {module:model/AddConcessionRequest} The populated <code>AddConcessionRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AddConcessionRequest();
      if (data.hasOwnProperty('applicationNumber'))
        obj.applicationNumber = ApiClient.convertToType(data['applicationNumber'], 'String');
      if (data.hasOwnProperty('studentName'))
        obj.studentName = ApiClient.convertToType(data['studentName'], 'String');
      if (data.hasOwnProperty('feeType'))
        obj.feeType = ApiClient.convertToType(data['feeType'], 'String');
      if (data.hasOwnProperty('amount'))
        obj.amount = ApiClient.convertToType(data['amount'], 'Number');
      if (data.hasOwnProperty('reason'))
        obj.reason = ApiClient.convertToType(data['reason'], 'String');
      if (data.hasOwnProperty('issuedBy'))
        obj.issuedBy = ApiClient.convertToType(data['issuedBy'], 'String');
      if (data.hasOwnProperty('issuedDate'))
        obj.issuedDate = ApiClient.convertToType(data['issuedDate'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} applicationNumber
 */
AddConcessionRequest.prototype.applicationNumber = undefined;

/**
 * @member {String} studentName
 */
AddConcessionRequest.prototype.studentName = undefined;

/**
 * Allowed values for the <code>feeType</code> property.
 * @enum {String}
 * @readonly
 */
AddConcessionRequest.FeeTypeEnum = {
  /**
   * value: "firstYearTuitionFee"
   * @const
   */
  firstYearTuitionFee: "firstYearTuitionFee",

  /**
   * value: "firstYearHostelFee"
   * @const
   */
  firstYearHostelFee: "firstYearHostelFee",

  /**
   * value: "secondYearTuitionFee"
   * @const
   */
  secondYearTuitionFee: "secondYearTuitionFee",

  /**
   * value: "secondYearHostelFee"
   * @const
   */
  secondYearHostelFee: "secondYearHostelFee"
};
/**
 * @member {module:model/AddConcessionRequest.FeeTypeEnum} feeType
 */
AddConcessionRequest.prototype.feeType = undefined;

/**
 * @member {Number} amount
 */
AddConcessionRequest.prototype.amount = undefined;

/**
 * @member {String} reason
 */
AddConcessionRequest.prototype.reason = undefined;

/**
 * @member {String} issuedBy
 */
AddConcessionRequest.prototype.issuedBy = undefined;

/**
 * @member {String} issuedDate
 */
AddConcessionRequest.prototype.issuedDate = undefined;

